import { render, staticRenderFns } from "./FurnitureUsers.vue?vue&type=template&id=287cd478&scoped=true&"
import script from "./FurnitureUsers.vue?vue&type=script&lang=js&"
export * from "./FurnitureUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287cd478",
  null
  
)

export default component.exports